import React from "react";

export const TopArrow = () => {
    return (
      <>
        <a className="top-arrow" href="#">
          <img
            className="top-arrow-icon"
            src="/static/images/top_arrow.png"
            alt="back to top"
          />
        </a>
      </>
    );
  }